import {setLocale} from 'yup'

export default defineNuxtPlugin(nuxtApp => {
  setLocale({
    string: {
      min: '최소 ${min}자 이상 입력해주세요.',
      max: '최대 ${max}자 이하 입력해주세요.'
    },
    number: {
      min: '최소 ${min}자 이상 입력해주세요.',
      max: '최대 ${max}자 이하 입력해주세요.'
    },
    mixed: {
      required: '필수 입력값입니다. 이 항목을 입력해주세요.',
      notType: '타입이 올바르지 않습니다. 이 항목을 입력해주세요.'
    },
    date: {
      min: '생년월일을 올바르게 입력해주세요. 예) 19750131',
      max: '생년월일을 올바르게 입력해주세요. 예) 19750131'
    }
  })
})
